/* eslint-disable camelcase */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { trackEvent } from '@offerzen/pinata-shame'

import { availableCountries, locationOsmStrings } from '../../redux/selectors/location'
import { loadingCandidate } from '../../selectors/currentUser'
import { nextOnboardingUrl } from '../../helpers/onboardingSteps'
import WorkplacePolicyForm from '../../compounds/WorkplacePolicyForm'

import { updateCandidate as reduxUpdateCandidate } from '../../redux/modules/candidate'
import { updateProgress as reduxUpdateProgress } from '../../redux/modules/utility'
import {
  formatWorkplacePolicyForDefaultValues,
  formatWorkplacePolicyForSubmit,
} from '../../../CandidateExperience/helpers/workplacePolicyHelpers'

const CitySelect = props => {
  const navProps = {
    history: props.history,
    location: props.location,
  }

  const defaultValues = formatWorkplacePolicyForDefaultValues(props.initialValues.remote_policies)

  const trackUser = () => {
    trackEvent('onboarding-city-select-accessed')
  }

  useEffect(() => {
    props.updateProgress(32)
    if (props.candidate) {
      trackUser()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const updateProfile = data => {
    const url = nextOnboardingUrl(props.location.pathname)
    const remote_policies = formatWorkplacePolicyForSubmit(data, locationOsmStrings)

    return props.updateCandidate(
      {
        remote_policies,
        onboarding_phase: 'about_you',
      },
      url,
    )
  }

  return (
    <WorkplacePolicyForm
      availableCountries={props.availableCountries}
      defaultValues={defaultValues}
      navProps={navProps}
      onSubmit={updateProfile}
      locationOsmStrings={props.locationOsmStrings}
    />
  )
}

const mapStateToProps = state => {
  return {
    loading: loadingCandidate(state),
    candidate: state.candidate,
    availableCountries: availableCountries(state),
    places: state.places,
    initialValues: {
      remote_policies: state.candidate.remote_policies,
    },
    locationOsmStrings: locationOsmStrings(state),
  }
}

const mapDispatchToProps = dispatch => ({
  updateCandidate: (candidate, nextRoute) => dispatch(reduxUpdateCandidate(candidate, nextRoute)),
  updateProgress: progress => dispatch(reduxUpdateProgress(progress)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CitySelect))

CitySelect.propTypes = {
  availableCountries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      code: PropTypes.string,
      created_at: PropTypes.string,
    }),
  ),
  updateProgress: PropTypes.func,
  candidate: PropTypes.shape({
    current_state: PropTypes.string,
    onboarding_phase: PropTypes.string,
    id: PropTypes.string,
    slug: PropTypes.string,
    user_id: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    location: PropTypes.string,
    transitioned_at: PropTypes.string,
    disabled: PropTypes.bool,
    located_in_europe: PropTypes.bool,
    region_code: PropTypes.string,
    phone: PropTypes.string,
    whatsapp_number: PropTypes.string,
    notice_period: PropTypes.string,
    github_url: PropTypes.string,
    linkedin_url: PropTypes.string,
    bitbucket_url: PropTypes.string,
    personal_site_url: PropTypes.string,
    dribbble_url: PropTypes.string,
    behance_url: PropTypes.string,
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
  updateCandidate: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  initialValues: PropTypes.shape({
    remote_policies: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  locationOsmStrings: PropTypes.shape({}),
}
